import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/lib/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          base: "#F12536",
          darken1: "#D02837",
        },
        secondary: "#109347",
        grey: {
          base: "#2E2E2E",
          lighten1: "#404040",
          lighten2: "#FBF8F6",
          lighten3: "#8E8E8E",
          lighten4: "#646464",
        },
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
  icons: {
    iconfont: "fa",
  },
});
